import { classNames } from '@framework/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePopupRef } from '@framework/hooks';
import { useCallback } from 'react';
import { faAngleRight, faFileImage } from '@fortawesome/free-solid-svg-icons';
import { MenuButton } from '../HeaderMenuLeft/MenuButton';

type Props = {
  onExportViewModelAsImage(isWhole: boolean): void;
};

export const ExportImageButtons: React.FC<Props> = ({ onExportViewModelAsImage }: Props) => {
  const { isOpen, popupRef, handleToggle } = usePopupRef<HTMLDivElement>(false);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      handleToggle();
    },
    [handleToggle]
  );

  return (
    <div className="relative hover:bg-gray-200">
      <button
        className={classNames('flex w-full cursor-pointer items-center pr-4 hover:bg-gray-200 focus:outline-none')}
        onClick={handleClick}
      >
        <span className="w-10 pl-2">
          <FontAwesomeIcon icon={faFileImage} />
        </span>
        <span className="py-2 pr-2">画像として書き出す | Export as Image</span>
        <FontAwesomeIcon icon={faAngleRight} className="ml-auto" />
      </button>
      <div
        className={classNames(
          'absolute -right-[14rem] top-0 z-50 h-[6rem] w-[14rem] rounded-lg bg-white py-2 shadow-2xl',
          isOpen ? 'block' : 'hidden'
        )}
        ref={popupRef}
      >
        <MenuButton onClick={() => onExportViewModelAsImage(true)} title="ビューモデル全体 | Entire" />
        <MenuButton onClick={() => onExportViewModelAsImage(false)} title="表示中の領域 | Visible" />
      </div>
    </div>
  );
};
